export default __webpack_public_path__ + "static/media/5.5c22aa10.jpg";